import { Model } from './model';

export class Ship extends Model {
  id: number;
  code: number;
  name: string;
  type: string;
  get_type_display: string;
  dea_user: string;
  dea_password: string;
  status: string;
  get_status_display: string;
  // Campo para evitar conflicto al editar un barco
  img?: string | null;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    return new Ship(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/ship.ts